import { render, staticRenderFns } from "./HotGoodsCard.vue?vue&type=template&id=609b30ce&scoped=true&"
import script from "./HotGoodsCard.vue?vue&type=script&lang=js&"
export * from "./HotGoodsCard.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/hotgoodscard.css?vue&type=style&index=0&id=609b30ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b30ce",
  null
  
)

export default component.exports